import styled from "styled-components";

export const ContainerPagina = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-right: 30px;
`;

export const ListaAnos = styled.ul`
  display: flex;
`;
export const ItemListaAnos = styled.li`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const TitleAno = styled.span`
  padding: 8px 15px 3px;
  border-radius: 25px 25px 0 0;
  font-size: 16px;
  font-weight: 100;
  width: fit-content;
  transition: background-color 0.4s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
  }
`;

export const ListaCategorias = styled.ul`
  background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
  border-radius: 0 25px 25px 25px;
  padding: 5px 0 0;
  width: fit-content;
  font-size: 16px;
  font-weight: 100;
  display: flex;
  width: 100%;

  li {
    padding: 15px 25px 19px;
    cursor: pointer;
    transition: background-color 0.4s, filter 0.4s;

    .info-qtd-arqs {
      color: ${({ theme }) => theme.colors.fonteLight};
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
      filter: brightness(0.9);
    }
    &.active {
      background-color: ${({ theme }) => theme.colors.backgroundAlternativo};
      filter: brightness(0.9);
    }
  }
`;

export const ListaArquivos = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 4px;

  li {
    cursor: pointer;
    padding: 6px 15px;
    border-radius: 8px;
    transition: filter 0.4s;
    display: flex;
    gap: 12px;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.backgroundAlternativo};

    &:hover {
      filter: brightness(0.95);
    }
    :nth-child(odd) {
    }
  }
`;

export const Separador = styled.div`
  height: 10px;
  width: 1px;
  background-color: ${({ theme }) => theme.colors.fonteLight};
`;
